import { Component, inject, Input, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ReclamationService } from 'src/app/services/reclamation.service';
type ImageState =
	| {
			image: File;
			status: 'success';
	  }
	| {
			image: null;
			status: 'idle' | 'uploading' | 'error';
	  };

@Component({
	selector: 'app-reclamation-finish-image-container',
	templateUrl: './reclamation-finish-image-container.component.html',
	styleUrls: ['./reclamation-finish-image-container.component.scss'],
})
export class ReclamationFinishImageContainerComponent {
	constructor() {}

	private readonly initialImageState: ImageState = { image: null, status: 'idle' };

	private _reclamation = inject(ReclamationService);

	@Input() maxImages = 8;

	images$: BehaviorSubject<Array<ImageState>> = new BehaviorSubject([{ ...this.initialImageState }]);

	addImage() {
		this.images$.next([...this.images$.value, { ...this.initialImageState }]);
	}

	handleNewImageUploaded(image: File, index: number) {
		let imageToUpdate = this.images$.value[index];
		if (index === this.images$.value.length - 1 && this.images$.value.length < this.maxImages) {
			this.addImage();
		}

		imageToUpdate.status = 'success';
		imageToUpdate.image = image;
		this._reclamation.addImageToUploadedImages(image.name);
		this.images$.next(this.images$.value);
	}
}
